import React from 'react';

const HOURS = Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0'));
const MINUTES = Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0'));

export function TimeInput24h({ value, onChange, className = "", disabled = false, "data-testid": testId }) {
  const [hours, minutes] = (value || '').split(':');
  const selectedHour = hours || '';
  const selectedMinute = minutes || '';

  const handleHourChange = (e) => {
    const h = e.target.value;
    onChange(h ? `${h}:${selectedMinute || '00'}` : '');
  };

  const handleMinuteChange = (e) => {
    const m = e.target.value;
    onChange(`${selectedHour || '00'}:${m}`);
  };

  return (
    <div className={`flex items-center gap-1 ${className}`} data-testid={testId}>
      <select
        value={selectedHour}
        onChange={handleHourChange}
        disabled={disabled}
        className="flex-1 border rounded-lg px-2 py-1.5 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-400"
      >
        <option value="">ЧЧ</option>
        {HOURS.map(h => <option key={h} value={h}>{h}</option>)}
      </select>
      <span className="text-lg font-bold text-slate-400">:</span>
      <select
        value={selectedMinute}
        onChange={handleMinuteChange}
        disabled={disabled}
        className="flex-1 border rounded-lg px-2 py-1.5 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-400"
      >
        <option value="">ММ</option>
        {MINUTES.map(m => <option key={m} value={m}>{m}</option>)}
      </select>
    </div>
  );
}
